import React from 'react';
import { useLocation } from 'react-router-dom';
import './App.css';

function Footer() {
  const location = useLocation();
  const isSwedish = location.pathname.startsWith('/sv'); // Check if in Swedish mode
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="row justify-content-center">
        <p>
          &copy; {currentYear} Jbygg {isSwedish ? "Ab" : "Oy"} | {isSwedish ? "FO-nummer" : "Y-tunnus"}: 3194121-7
        </p>
      </div>
    </footer>
  );
}

export default Footer;